module.exports = __webpack_public_path__ + "static/img/5diamond-card@3x.3c8e2f4a.png";